import React, { FC, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  getImportToken,
  postStudentRegisterImport,
  deleteStudentRegisterImport,
  getImportFileName,
} from 'store/institutions';
import { FileImport } from './FileImport';
import { StepProps } from 'components/shared/dialogs/StepModal/StepModal.types';


export const FileImportContainer: FC<StepProps> = (props) => {
  const dispatch: (...params: any) => Promise<any> = useDispatch();
  const importToken = useSelector(getImportToken);
  const { id } = useParams<{ id: string }>();
  const fileName = useSelector(getImportFileName);

  const deleteStudentRegisterImportCallback = useCallback(() => {
    return dispatch(deleteStudentRegisterImport(importToken, id));
  }, [dispatch, importToken, id]);

  const postStudentRegisterImportCallback = useCallback(
    (result) => {
      return dispatch(postStudentRegisterImport(result, id));
    },
    [id, dispatch],
  );

  return (
    <FileImport
      {...props}
      deleteStudentRegisterImport={deleteStudentRegisterImportCallback}
      postStudentRegisterImport={postStudentRegisterImportCallback}
      token={importToken}
      fileName={fileName}
    />
  );
};
